<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Fitting Type"
    item-text="name"
    item-value="id"
    :disabled="disabled"
    :rules="rules"
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: ["value", "disabled", "rules"],
  watch: {
    model() {
      this.$emit("input", this.model);
    }
  },
  mounted: function() {
    this.getFittingType();
  },
  methods: {
    getFittingType() {
      this.$store
        .dispatch("fittingTypes/index", {})
        .then(({types}) => {
          this.items = types.data.filter(t => t.status==='active');
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
